(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quick-add"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__wimQaInit) return;
  window.__wimQaInit = true;

  const localCart = {};

  async function cartAdd(id, qty) {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity: qty })
    });
    if (!r.ok) throw new Error('cart_add_failed');
    return r.json();
  }

  async function cartChange(id, qty) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity: qty })
    });
    if (!r.ok) throw new Error('cart_change_failed');
    return r.json();
  }

  async function syncFromServer(id) {
    const r = await fetch('/cart.js');
    const cart = await r.json();
    const item = cart.items.find(i => i.variant_id == id);
    localCart[id] = item ? item.quantity : 0;
    return localCart[id];
  }

  function getLocalQty(id) { return localCart[id] || 0; }

  function showError(root, msg) {
    let el = root.querySelector('.wim-qa__error');
    if (!el) {
      el = document.createElement('span');
      el.className = 'wim-qa__error';
      root.querySelector('.wim-qa__panel').appendChild(el);
    }
    el.textContent = msg;
    el.style.display = 'block';
    clearTimeout(el._t);
    el._t = setTimeout(() => { el.style.display = 'none'; }, 3000);
  }

  function applyUI(root, qty) {
    const badge = root.querySelector('.wim-qa__badge');
    const qtySpan = root.querySelector('.wim-qa__qty');
    qtySpan.textContent = qty;
    badge.textContent = qty;
    badge.style.display = qty > 0 ? 'flex' : 'none';
    if (qty === 0) closePanel(root);
  }

  function closeAllExcept(exceptRoot) {
    document.querySelectorAll('.wim-qa[data-wim-open]').forEach(root => {
      if (root !== exceptRoot) closePanel(root);
    });
  }

  function openPanel(root) {
    root.querySelector('.wim-qa__panel').hidden = false;
    root.querySelector('.wim-qa__trigger').style.display = 'none';
    root.setAttribute('data-wim-open', '1');
  }

  function closePanel(root) {
    root.querySelector('.wim-qa__panel').hidden = true;
    root.querySelector('.wim-qa__trigger').style.display = '';
    root.removeAttribute('data-wim-open');
  }

  function initRoot(root) {
    const id = root.dataset.variantId;
    syncFromServer(id).then(qty => applyUI(root, qty));

    const trigger = root.querySelector('.wim-qa__trigger');
    const btnPlus = root.querySelector('.wim-qa__btn-plus');
    const btnRemove = root.querySelector('.wim-qa__btn-remove');
    const btnRemoveAll = root.querySelector('.wim-qa__remove-all');
    const btnClose = root.querySelector('.wim-qa__close');

    trigger.addEventListener('click', async e => {
      e.preventDefault(); e.stopPropagation();
      closeAllExcept(root);
      if (getLocalQty(id) === 0) {
        const prev = 0;
        localCart[id] = 1;
        applyUI(root, 1);
        openPanel(root);
        try { await cartAdd(id, 1); }
        catch { localCart[id] = prev; applyUI(root, prev); showError(root, 'Error al agregar. Intenta de nuevo.'); }
      } else {
        openPanel(root);
      }
    });

    btnClose.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); closePanel(root); });

    btnPlus.addEventListener('click', async e => {
      e.preventDefault(); e.stopPropagation();
      const prev = getLocalQty(id);
      const next = prev + 1;
      localCart[id] = next; applyUI(root, next);
      try { await cartAdd(id, 1); }
      catch { localCart[id] = prev; applyUI(root, prev); showError(root, 'Error al agregar. Intenta de nuevo.'); }
    });

    btnRemove.addEventListener('click', async e => {
      e.preventDefault(); e.stopPropagation();
      const prev = getLocalQty(id);
      if (prev <= 0) return;
      const next = prev - 1;
      localCart[id] = next; applyUI(root, next);
      try { await cartChange(id, next); }
      catch { localCart[id] = prev; applyUI(root, prev); showError(root, 'Error al quitar. Intenta de nuevo.'); }
    });

    btnRemoveAll.addEventListener('click', async e => {
      e.preventDefault(); e.stopPropagation();
      const prev = getLocalQty(id);
      localCart[id] = 0; applyUI(root, 0);
      try { await cartChange(id, 0); }
      catch { localCart[id] = prev; applyUI(root, prev); openPanel(root); showError(root, 'Error al eliminar. Intenta de nuevo.'); }
    });

    root.querySelectorAll('.wim-qa__preset-btn').forEach(btn => {
      btn.addEventListener('click', async e => {
        e.preventDefault(); e.stopPropagation();
        const addQty = parseInt(btn.dataset.qty, 10);
        const prev = getLocalQty(id);
        const next = prev + addQty;
        localCart[id] = next; applyUI(root, next);
        try { await cartAdd(id, addQty); }
        catch { localCart[id] = prev; applyUI(root, prev); showError(root, 'Error al agregar. Verifica el stock.'); }
      });
    });
  }

  document.addEventListener('click', e => {
    if (!e.target.closest('.wim-qa')) {
      document.querySelectorAll('.wim-qa[data-wim-open]').forEach(closePanel);
    }
  });

  function attachAll() {
    document.querySelectorAll('.wim-qa:not([data-wim-init])').forEach(root => {
      root.setAttribute('data-wim-init', '1');
      initRoot(root);
    });
  }

  document.addEventListener('DOMContentLoaded', attachAll);
  new MutationObserver(attachAll).observe(document.body, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

})();
